import { createAsyncThunk } from '@reduxjs/toolkit'
import MediationProcessTemplate from './mediation-process-template-model'
import {
  delete_mediationProcessTemplate,
  load_mediationProcessTemplates,
  store_mediationProcessTemplate,
} from './mediationProcessTemplate-service'

export const LoadMediationProcessTemplatesAsync = createAsyncThunk<any, any>(
  'composer/load/mediationProcessTemplate',
  async (params: { uid: string }) => {
    return await load_mediationProcessTemplates(params)
  },
)

export const CreateMediationProcessTemplateAsync = createAsyncThunk<any, any>(
  'composer/create/mediationProcessTemplate',
  async (params: MediationProcessTemplate) => {
    return await store_mediationProcessTemplate(params)
  },
)

export const DeleteMediationProcessTemplateAsync = createAsyncThunk<any, any>(
  'composer/delete/mediationProcessTemplate',
  async (params) => {
    return await delete_mediationProcessTemplate(params)
  },
)
